module.exports = __webpack_public_path__ + "img/滤镜牛奶.fdf164f8.png";